import styles from './ReturnToSellerCTA.module.css';
import { useGetPaymentStatus } from '../useGetPaymentStatus';
import { usePaymentId } from '../usePaymentId';

export const ReturnToSellerCTA = () => {
  const paymentId = usePaymentId();
  const { paymentData } = useGetPaymentStatus(paymentId);

  const isFailure = paymentData?.status === 'failed';

  return (
    <a
      href={paymentData?.order?.redirect_url}
      className={styles.returnToSellerCTA}
    >
      Return to {paymentData?.seller_trading_name}{' '}
      {isFailure ? <div>and try again</div> : null}
    </a>
  );
};
